export default __webpack_public_path__ + "static/media/Hashtag Hijacking Insights - 04 - Effective tactic.f25bd773.pdf";